import { plan } from './plan';

export const salesforce = {
  plan,
};
